<div class="table-menu" *ngIf="filteredOptions.length > 0">
  <button class="menu-button" [matMenuTriggerFor]="menu"   (click)="$event.stopPropagation()">
    <app-svg-icon [path]="'assets/icons/more_menu_vertical_icon.svg'"></app-svg-icon>
  </button>
  <mat-menu #menu="matMenu">
    <button
      mat-menu-item
      *ngFor="let option of filteredOptions"
      (click)="onOptionSelect(option)"
    >
      <span>{{ option.label }}</span>
    </button>
  </mat-menu>
</div>
